import { Box, Text } from "@chakra-ui/react";
import React from "react";
import DataTableV2 from "../../../../components/DataTable/DateTableV2";
import { formatDate } from "../../../../utils";
import { CaretCircleRight } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config";
import A from "components/A";

const CompletedAuditList = ({ auditList }) => {
  const navigate = useNavigate();

  const columns = [
    {
      header: "Type",
      accessorKey: "type",
    },
    {
      header: "Start Date",
      accessorKey: "startDate",
      cell: ({ cell }) => formatDate(new Date(cell.getValue()), false, false),
    },
    {
      header: "End Date",
      accessorKey: "endDate",
      cell: ({ cell }) => formatDate(new Date(cell.getValue()), false, false),
    },
    {
      header: "Questions",
      accessorKey: "totalQuestions",
    },
    {
      header: "Auditors",
      accessorKey: "auditors",
    },
    {
      header: "",
      accessorKey: "actions",
      cell: ({ cell }) => {
        const audit = cell.row.original;
        return (
          <Box>
            <A href={`${routes.issbCompletedAudit}?id=${audit.id}`}>
              <CaretCircleRight size={32} weight="fill" />
            </A>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <Text color="whiteShade.500" fontSize="heading.s" fontWeight="700">
        Completed Audits
      </Text>
      <DataTableV2 data={auditList} columns={columns} serverSidePagination={false} showPaginator={false} />
    </>
  );
};

export default CompletedAuditList;
